const styleOverrides = {};
const defaultProps = {
  InputLabelProps: {
    shrink: true
  }
};
export default {
  styleOverrides,
  defaultProps
};